import { render } from "./SmallReport.vue?vue&type=template&id=37f65820&scoped=true"
import script from "./SmallReport.vue?vue&type=script&lang=js"
export * from "./SmallReport.vue?vue&type=script&lang=js"

import "./SmallReport.vue?vue&type=style&index=0&id=37f65820&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f65820"]])

export default __exports__